/**
 * Is a fetched scene effectively blank?
 *
 * A Sentinel-2 tile only partly covers its own 100km square on most passes, so a
 * date can exist in the archive while holding no pixels over the user's bbox --
 * `get-s2` returns 200 with an all-black JPEG. Measured 2026-09-30 for a bbox in
 * Valencia against tile 30TYK: 54 of 131 listed 2026 dates (41%) have no pass
 * whose `tileDataGeometry` contains the point, and every one of those renders
 * black.
 *
 * The map timeline has always dropped these; the Image list did not, which is
 * why it showed a wall of black squares. Both now share this predicate.
 */
export const isImageBlack = (img) => {
  if (!img) return false;
  if (img.black_percentage !== undefined && img.black_percentage !== null) {
    return img.black_percentage > 50;
  }
  return img.is_black === true;
};

export default isImageBlack;
